// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1ly5X","header":"PatientQuestionnaire_header__BweAe","info":"PatientQuestionnaire_info__3w2ss"};